import React from 'react';

export function PeriodicElement(props){

    return (

        <div className={"border border-dark text-white chemical-element clickable"} style={{backgroundColor:props.color}}>
            <p style={{fontSize:"0.7em"}} className={" m-0 text-center"}>{props.element.atomicNumber}</p>
            <h2 className={"text-center m-0"} style={{fontSize:"1em"}}>{props.element.symbol}</h2>
            <p className={"text-center m-0"} style={{fontSize:"0.5em"}}>{props.element.name}</p>
        </div>

    );


}